import styled from "@emotion/styled";
import { BREAKPOINT_RESERVATION_PAGE } from "../../pageComponents/reservationPage/constants/breakpoints";

interface DividerProps {
  $margin?: string;
}

export const Divider = styled.hr<DividerProps>`
  border: none;
  border-top: 1px solid #D8DBE0;
  margin: ${({ $margin }) => $margin ?? "24px 0"};

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    margin: ${({ $margin }) => $margin ?? "16px 0"};
  }
`;
